module.exports = __webpack_public_path__ + "img/object-feature-person-after.ce485562.webp";